import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Badge, Tabs } from "stories/Admin";
import {
  countFor,
  useInquirySummary,
} from "pages/SuperAdminPages/InquiriesPage/inquiries";
import { AdminRole, menuGroupsFor } from "./menuConfig";

const ROLES: AdminRole[] = ["moske", "superadmin", "mawaqeet"];

/**
 * Route based tabs for menu items that group several pages (Push, Duaer/navn/
 * uttrykk, Test og AI-imam, TV). Place it under the PageHeader of those pages.
 * Searches the menus of all roles, so it works for mosque admins too.
 */
const SectionTabs: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const summary = useInquirySummary();
  const item = ROLES.flatMap((role) => menuGroupsFor(role))
    .flatMap((g) => g.items)
    .find((i) => i.tabs?.some((t) => t.path === location.pathname));
  if (!item?.tabs) return null;
  return (
    <Tabs
      label={item.label}
      value={location.pathname}
      onChange={(path) => navigate(path)}
      tabs={item.tabs.map((t) => {
        const count = countFor(summary, t.count);
        return {
          value: t.path as string,
          label: t.label,
          extra:
            count > 0 ? (
              <Badge tone="gold">{count.toLocaleString("nb-NO")}</Badge>
            ) : undefined,
        };
      })}
    />
  );
};

export default SectionTabs;
